import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import BubbleLoader from '../../../Libraries/Loader/bubble-loader';
import { usePools } from '../DatabaseContext';
import FormContainer from '../Fields/FormContainer';
import SaveAndContinue from '../Fields/SaveAndContinue';
import TextQuestion from '../Fields/TextQuestion';

export default function PoolNamePage({ i18n }) {
    const { id } = useParams()
    const { setPoolId, pool, clearPool } = usePools()
    const [name, setName] = useState('')

    useEffect(() => {
        if (id) {
            setPoolId(id)
        } else {
            setName('')
            clearPool()
        }
    }, [id])

    useEffect(() => {
        setName(pool?.name)
    }, [pool])

    if (!pool && id) {
        return <BubbleLoader />
    }

    const heading = id ? (name || id) : i18n.name.heading;

    return <FormContainer needsValidPool={ false } title={ heading } breadcrumb={[
        { label: heading },
    ]} >

        <TextQuestion
            value={ name }
            onChange={ setName }
            name="name"
            label={i18n.name.label}
        />

        <SaveAndContinue id={ pool?.id } data={{ name }} next="dimensions" />

    </FormContainer>
}
